import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ComparisonDashboard from "@/components/ComparisonDashboard";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComparisonDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;